(function () {
    angular.module('bizPartEngage').directive('bizMyGoals', bizMyGoalsDirective);    

    bizMyGoalsDirective.$inject = ["bizCore"];    

    function bizMyGoalsDirective(bizCoreProvider) {
        var directive = {
            restrict: 'E',
            scope: {
                showActiveFilter: '@?',
                goalFilter: '@?',
                hideActivities: '@?',
                hideEdit: '@?',
                hideTasks: '@?',
                selectedGoal: '=?',
                Goals: '=?goals',
                editProgress: '@?',
                parentId: '=?',
                rootGoals: '=?'
            },
            templateUrl: bizCoreProvider.getView('bizMyGoalsDirective', 'FrontEnd/Modules/EngagementGoals/Views/Directives/myGoals.html'),
            bindToController: true,
            controller: bizMyGoalsController,
            controllerAs: 'vm'
        };

        bizMyGoalsController.$inject = ["modules.goals.service", "$state", "$rootScope", "$mdToast"];

        return directive;

        function bizMyGoalsController(engagementGoalsService, $state, $rootScope, $mdToast) {
            var vm = this;

            vm.ActiveStatus = [
                {
                    Name: 'Aktiva',
                    Active: true,
                    Icon: "fas fa-check-square"
                },
                {
                    Name: 'Inaktiva',
                    Active: false,
                    Icon: "fas fa-times-square"
                }
            ];

            vm.ProgressObjectTypes = {
                Goal: 200,
                Activity: 201,
                Task: 202,                
            };

            vm.GetGoals = GetGoals;
            vm.FilterGoals = FilterGoals;
            vm.CompleteToDo = CompleteToDo;
            vm.Init = Init;
            vm.GotoToGoal = GotoToGoal;
            vm.GotoActivity = GotoActivity;
            vm.IsExpired = IsExpired;            
            vm.SaveProgress = SaveProgress;

            function IsExpired(task) {
                return !task.IsCompleted && moment(task.DateLocal) < BizPartCoreHelpers.getDateNow();
            }

            function GotoToGoal(goal) {
                $state.go("base.modules.goals.onegoal", { id: goal.Id });
            }

            function GotoActivity(activity) {
                $state.go("base.modules.goals.activity", { id: activity.Id });
            }

            function FilterGoals() {
                return function (goal) {
                    if (vm.rootGoals) {
                        return goal.ParentGoalId <= 0;
                    } else if (goal.ParentGoalId <= 0) {                        
                        return false;
                    } else if (vm.parentId > 0) {
                        return vm.parentId === goal.ParentGoalId;
                    } else if (vm.goalFilter && ~~vm.goalFilter > 0) {
                        return ~~vm.goalFilter === goal.Id;
                    } else {
                        return vm.SelectedActiveStatus.Active === goal.IsActive;
                    }
                }
            }

            function GetGoals() {
                if (vm.parentId) {                    
                    engagementGoalsService.GetChildGoals(vm.parentId).then(GetGoalsCallback);
                } else {
                    engagementGoalsService.GetGoals(true).then(GetGoalsCallback);      
                }
                

                function GetGoalsCallback(response) {
                    var goals = BizPartCoreHelpers.getResponseValue(response, []);                    
                    for (var i = 0; i < goals.length; i++) {
                        goals[i].ReportProgress = goals[i].ProgressSum;
                        for (var j = 0; j < goals[i].Activities.length; j++) {                            
                            var act = goals[i].Activities[j];
                            act.ReportProgress = act.ProgressSum;

                            for (var k = 0; k < act.ToDoList.length; k++) {
                                var tsk = act.ToDoList[k];
                                tsk.ReportProgress = tsk.ProgressSum;
                            }
                        }
                    }
                    vm.Goals = goals;                    
                }
            }

            function CompleteToDo(todo, act) {
                engagementGoalsService.CompleteTask(todo).then(CompleteToDoCallback);

                function CompleteToDoCallback(response) {
                    var index = act.ToDoList.indexOf(todo);
                    act.ToDoList.splice(index, 1);
                }
            }            

            function SaveProgress(object, objectType) {
                //Remove spaces to make it a valit integer.
                var rp = ~~object.ReportProgress.replace(/\s/g, '');
                var pList = [];
                if (object.ProgressSum !== rp) {
                    var diff = rp - object.ProgressSum;
                    pList.push({
                        LinkedObjectType: objectType,
                        LinkedObjectId: object.Id,
                        Value: diff,
                        DateLocal: moment()
                    });

                    engagementGoalsService.CreateProgress(pList).then(CreateProgressCallback);
                }

                function CreateProgressCallback(response) {
                    object.ProgressSum = ~~object.ReportProgress.replace(/\s/g, '');

                    object.Saved = true;

                    $rootScope.$broadcast('GOALPROGRESSUPDATED');

                    if($rootScope.mobile) {
                        $mdToast.show({
                            parent: $(".bizpart-engage"),
                            template: "<md-toast><p style='color: #FFFFFF'><i style='color: green; margin-right: 10px;' class='fas fa-check-circle'></i> Sparat!</p></md-toast>",
                            autoWrap: true
                        });
                    }
                }
            }

            function Init() {
                vm.SelectedActiveStatus = vm.ActiveStatus[0];
                if(vm.Goals === undefined) {
                    vm.GetGoals();
                }
            }

            vm.$onInit = vm.Init;

            $rootScope.$on('GOAL_NEW_DATE_SELECTED', function () {
                vm.GetGoals();
            });

            $rootScope.$on('GOALACTIVITYCREATED', function (event, activity) {                
                var goal = vm.Goals.GetItemByValue('Id', activity.GoalId);
                if (goal) {
                    activity.ReportProgress = 0;
                    goal.Activities.push(activity);                                    
                }                    
            });

            $rootScope.$on('GOALCREATED', function (event, goal) {
                vm.Goals.push(goal);
                goal.ReportProgress = 0;                
            });
        }
    }    

}());